export class Opm {
  id = 0;
  opm = '';
}
